import React from 'react';
import {
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  InputRightAddon,
} from '@wegroup/design-system';

// Components
import { TextInput as TextInputComponent } from 'wg-fe-ui';
import { FieldError } from 'react-hook-form';

interface Props {
  error?: FieldError;
  symbol?: string;
  isDisabled?: boolean;
}

const TextInput: React.FC<
  React.PropsWithChildren<typeof TextInputComponent & Props>
> = ({ prefilled, error, symbol, isDisabled, ...props }) => {
  return (
    <FormControl isInvalid={!!error} isDisabled={isDisabled}>
      <InputGroup variant={prefilled ? 'flowsPrefilled' : 'flows'}>
        <Input
          isDisabled={isDisabled}
          cursor={isDisabled ? 'not-allowed' : 'text'}
          {...props}
        />
        {symbol && <InputRightAddon>{symbol}</InputRightAddon>}
      </InputGroup>
      {error?.message && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};

export default TextInput;
